<template>
    <b-col sm>
      <label>{{ name }}</label>
      <b-form-group>
        <b-form-radio v-for="(radio, index) in items" :key="index" v-model="value" :value="radio">{{ radio }}</b-form-radio>
      </b-form-group>
    </b-col>
</template>

<script>

export default {
  name: 'radio-buttons',
  props: ['items', 'name', 'property'],
  computed: {
    value: {
      get() {
        return this.$store.state.form[this.property]
      },
      set(value) {
        this.$store.commit('setFormProperty', {property: this.property, value })
      }
    }
  }
}
</script>

<style scoped>

label, legend {
  font-weight: bold;
}

.otherBox {
  display: inline-flex;
  align-items: center;
}

</style>

